export default __webpack_public_path__ + "static/Graphik-RegularItalic-Web-62688ceebfa1f33aa27c279697bd21ff.eot";